import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: string | number;
  rate?: string | number;
  rateLabel?: string;
  description?: string;
  icon: LucideIcon;
  color?: 'blue' | 'emerald' | 'violet' | 'rose' | 'amber';
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  rate,
  rateLabel,
  description,
  icon: Icon,
  color = 'blue'
}) => {
  const colorMap = {
    blue: {
      bg: 'bg-blue-500/10 border-blue-500/20 text-blue-500',
      iconBg: 'bg-blue-500/10 text-blue-400'
    },
    emerald: {
      bg: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-500',
      iconBg: 'bg-emerald-500/10 text-emerald-400'
    },
    violet: {
      bg: 'bg-violet-500/10 border-violet-500/20 text-violet-500',
      iconBg: 'bg-violet-500/10 text-violet-400'
    },
    rose: {
      bg: 'bg-rose-500/10 border-rose-500/20 text-rose-500',
      iconBg: 'bg-rose-500/10 text-rose-400'
    },
    amber: {
      bg: 'bg-amber-500/10 border-amber-500/20 text-amber-500',
      iconBg: 'bg-amber-500/10 text-amber-400'
    }
  };

  const selectedColor = colorMap[color];

  return (
    <div className="glass-panel glass-panel-hover rounded-2xl p-6 flex items-start justify-between">
      <div className="space-y-2">
        <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider block">
          {title}
        </span>
        <div className="flex items-baseline gap-2">
          <span className="text-3xl font-bold text-slate-800 dark:text-white tracking-tight">
            {value}
          </span>
          {rate !== undefined && (
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${selectedColor.bg}`}>
              {rate}%
            </span>
          )}
        </div>
        
        {rateLabel && rate !== undefined && (
          <span className="text-xs text-slate-500 block">
            {rateLabel}
          </span>
        )}
        
        {description && (
          <span className="text-xs text-slate-500 block">
            {description}
          </span>
        )}
      </div>

      <div className={`w-12 h-12 rounded-xl flex justify-center items-center ${selectedColor.iconBg}`}>
        <Icon size={24} />
      </div>
    </div>
  );
};
export default StatsCard;
